import axios from "axios";
import Swal from "sweetalert2";
import { updateSolicitacao } from "./api_cadastros_solicitacoes_servico";
import getDateHour from "../hooks/GetDateHour";
import api from "./api_refresh_token";
import { isObject } from "formik";
import { baseURL } from "./api_base";

axios.defaults.headers.common["Access-Control-Allow-Origin"] =
  "GET, POST, DELETE, PUT"; // definindo o que meu axios pode fazer

//Token
const getToken = () => {
  let token = localStorage.getItem("token");
  return token;
};

export const postOrdem = async (body, idSolicitacao) => {
  try {
    const response = await api.post(`${baseURL}/ordensservico_store`, body, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": `multipart/form-data`,
      },
    });

    // Verifica se existe um ID de solicitação para atualizar
    if (idSolicitacao) {
      await updateSolicitacao(
        idSolicitacao,
        {
          situacao: "1",
          data_hora_aprovacao: getDateHour(),
        },
        true
      );

      Swal.fire({
        icon: "success",
        title: "Ordem de serviço cadastrada com sucesso!",
        text: "A solicitação de serviço foi aprovada e vinculada a esta ordem de serviço.",
      });
    } else {
      Swal.fire({
        icon: "success",
        title: "Ordem de serviço cadastrada com sucesso",
      });
    }

    return response;
  } catch (error) {
    if (error.response && error.response.status === 422) {
      const data = error.response.data;

      // Verifica se existe apenas um erro ou múltiplos
      if (data.length === 1) {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: data[0].errors, // Exibe o erro diretamente
        });
      } else { // Caso exista mais de um erro, lança ele para ser tratado por quem fez a chamada da função
        throw error.response.data;
      }
    } else if (error.response && error.response.status === 500) {
      Swal.fire({
        icon: "error",
        title: "Erro interno do servidor",
        text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
      });
    } else {
      console.log(error);
    }
  }
};

/// buscar id's
export const getOrdemById = (id) =>
  api
    .get(
      `${baseURL}/ordensservico/${id}`,

      // url base + rota de busca
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    )
    .then((response) => {
      // promise ( resposta da requisição )
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });

// PUT empresas

export const updateOrdem = (id, body, isConcludingOrCanceling) =>
  api
    .post(
      `${baseURL}/ordensservico_update/${id}`,
      // url base + rota de busca
      body,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": `multipart/form-data`,
        },
      }
    )
    .then((response) => {
      if (!isConcludingOrCanceling) {
        Swal.fire({
          icon: "success",
          title: "Registro alterado com sucesso",
        });
      }
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        return Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        return Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });

// Delete

export const deleteOrdem = (id) =>
  api
    .delete(
      `${baseURL}/ordensservico_delete/${id}`,
      // url base + rota de busca

      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": `application/json`,
        },
      }
    )
    .then((response) => {
      // promise ( resposta da requisição )

      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });
